"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createUploadButtonStyle;

function createUploadButtonStyle(_ref) {
  var sendBoxButtonColor = _ref.sendBoxButtonColor,
      sendBoxButtonColorOnFocus = _ref.sendBoxButtonColorOnFocus,
      sendBoxButtonColorOnHover = _ref.sendBoxButtonColorOnHover,
      sendBoxHeight = _ref.sendBoxHeight;
  return {
    // We use the sendBoxHeight, so the button looks square
    width: sendBoxHeight,
    '& > .icon > svg': {
      fill: sendBoxButtonColor
    },
    '& > input:hover + .icon > svg': {
      fill: sendBoxButtonColorOnHover
    },
    '& > input:focus + .icon > svg': {
      fill: sendBoxButtonColorOnFocus
    }
  };
}